import { useCallback } from 'react';
import { useSetShowLicenseModal } from 'redux/hooks/common';
import useProductEdition from 'CustomHooks/useProductEdition';
import { EProductEditions } from 'enums/EProductEditions';
import { EUserAction } from 'constants/index';

const LicenseViolationActionMap = {
  [EProductEditions.PlateViewer]: [
    EUserAction.ExperimentReport,
    EUserAction.DesignReport,
    EUserAction.SynchrotronTripReport,
    EUserAction.EditExperiment,
    EUserAction.GridLayer,
    EUserAction.RandomLayer,
    EUserAction.CustomLayer,
    EUserAction.Optimization,
    EUserAction.MarkAsDispensed,
    EUserAction.ScreenStockReport,
    EUserAction.IngredientReport,
  ],

  [EProductEditions.ExperimentDesigner]: [
    EUserAction.Optimization,
    EUserAction.InstantDropReport,
    EUserAction.ExperimentReport,
    EUserAction.DesignReport,
    EUserAction.IngredientReport,
    EUserAction.ImageReport,
    EUserAction.SingleDropReport,
    EUserAction.WellReport,
    EUserAction.ScoreReport,
    EUserAction.SynchrotronTripReport,
    EUserAction.SynchrotronTrip,
    EUserAction.ImageNow,
    EUserAction.Imaging,
    EUserAction.SendToMarco,
  ],

  [EProductEditions.Enterprise]: [],
};
const authorize = (action: EUserAction, productEdition: EProductEditions) => {
  return !LicenseViolationActionMap[productEdition]?.find((a) => a === action);
};

export const useLicenseAuthorizeCommand = () => {
  const productEdition = useProductEdition();
  const _setShowLicensModal = useSetShowLicenseModal();
  const authorizeAndExecute = useCallback(
    (clickEvent, action: EUserAction) => {
      if (authorize(action, productEdition)) {
        return clickEvent;
      } else {
        return () => {
          _setShowLicensModal(true);
        };
      }
    },
    [productEdition],
  );
  return authorizeAndExecute;
};
